import { useEffect } from "react";
import dayjs from "dayjs";
import { useDatatableContext } from "@/components/tables/contexts/DatatableContextProvider";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { DateRange } from "@/components/dateRange/DateRange";

const DiscoverDateRange = () => {
  const { getFilterValue, registerFilters } = useDatatableContext();
  const { updateSearchParamsByKey } = useFiltersBySearchParams();

  // Register date filters
  useEffect(() => {
    registerFilters({
      startDate: {
        label: "Start Date",
        defaultValue: dayjs().subtract(30, "day").toDate(),
      },
      endDate: {
        label: "End Date",
        defaultValue: dayjs().toDate(),
      },
    });
  }, [registerFilters]);

  // Get current date filters (handle both Date objects and ISO strings from search params)
  const startDateValue = getFilterValue("startDate");
  const endDateValue = getFilterValue("endDate");

  const startDate = startDateValue
    ? startDateValue instanceof Date
      ? startDateValue
      : new Date(startDateValue as string)
    : dayjs().subtract(30, "day").toDate();

  const endDate = endDateValue
    ? endDateValue instanceof Date
      ? endDateValue
      : new Date(endDateValue as string)
    : dayjs().toDate();

  const updateDateRange = (newStartDate: Date, newEndDate: Date) => {
    // Update search params instead of directly updating context
    updateSearchParamsByKey({
      startDate: newStartDate.toISOString(),
      endDate: newEndDate.toISOString(),
    });
  };

  return (
    <DateRange
      startDate={startDate}
      endDate={endDate}
      onDateRangeSelect={updateDateRange}
      variant="inline"
    />
  );
};

export default DiscoverDateRange;
